import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../components/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useOrder} from '../hooks/useOrder.ts';
import {useOrdersSelection} from '../hooks/useOrdersSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';

export const EditPage = () => {

    const {orderId} = useParams();

    if (typeof orderId === 'undefined') {
        throw new Error('orderId is required parameter');
    }

    const {
        record: order,
        loading,
        updateRecord,
    } = useOrder(orderId);

    const {handleClearSelection} = useOrdersSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    if (loading || !order) {
        return <PlatformLoader message='Loading order...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={order.id}
            pageNavigation={<EditPageNavigation component={order}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={order}
                    />

                    {/*
                    <AccountsPage/>
*/}

                </Stack>
                :
                <RecordForm
                    record={order}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};